<template>
  <Activity :title="t(`app.main.button.deliveries.${context}`)"
            :vertical="!loaded && !online ? 'center' : 'top'"
            :back="{ name: 'DeliveryListActivity', params: { context } }"
            class="report">
    <offline-indicator v-if="!loaded && !online" />

<!--    <delivery-details :disabled="!loaded && loading" :delivery="{ additions: [ 8 ], articles: [ { articleId: 2, pieces: 1, weight: 10, notice: 'foobar', naativityId: 'e8b8558c-2fd7-4b58-bbf7-0045bfd3589d' } ] }" v-else/>-->
    <delivery-details :context="context" :disabled="!loaded && loading" v-else>
      <template #buttons>
        <app-alert id="save-dialog"
                   title="PDF-Generierung nicht möglich"
                   message="Bitte speichen Sie den Lieferschein und versuchen es erneut."
                   :style="{ display: 'inline-block' }">
          <b-button variant="primary" :style="{ opacity: .5 }" v-b-modal.save-dialog>
            <font-awesome-icon icon="file-pdf"/>
            PDF
          </b-button>
        </app-alert>
      </template>
    </delivery-details>

  </Activity>
</template>

<script>
import DeliveryDetails from "@/app/components/delivery/DeliveryDetails.vue";
import Activity from "@/app/components/Activity.vue";
import OfflineIndicator from "@/app/components/OfflineIndicator.vue";
import { computed, ref } from "@vue/composition-api";
import AppAlert from "@/app/components/general/AppAlert.vue";

export default {
  components: {AppAlert, OfflineIndicator, Activity, DeliveryDetails},
  setup() {
    const store = window.useStore()
    const { t } = window.useI18n()
    const { currentRoute } = window.useRouter()

    const context = ref(currentRoute.params.context)

    const producersLoaded = computed(() => store.state.pwa.pigSty.lastFetched !== null)

    const online = computed(() => store.state.pwa.online)
    const loading = computed(() => store.getters['backgroundDataLoading'])
    const loaded = computed(() => producersLoaded.value)

    return {
      t,
      context,
      online,
      loading,
      loaded,
    }
  }
}
</script>
